// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1NEod","unreadBadge":"styles_unreadBadge__3t4U5","modalContent":"styles_modalContent__RQIW1","modal":"styles_modal__2W8Xs"};